import {Currency, Product, Selection} from './types';

export const money = (minor: number, currency: Currency) => {
    const [whole, fraction] = (minor / (10 ** currency.decimals)).toFixed(currency.decimals).split('.');
    const number = whole.replace(/\B(?=(\d{3})+(?!\d))/g, currency.thousand) + (fraction ? currency.decimal + fraction : '');
    if (currency.position === 'right') return number + currency.symbol;
    if (currency.position === 'right_space') return number + ' ' + currency.symbol;
    return currency.symbol + (currency.position === 'left_space' ? ' ' : '') + number;
};

export const matchVariant = (product?: Product, selection?: Selection) => {
    if (!product || !selection || product.attributes.some(a => !selection.attributes[a.key])) return undefined;
    return product.variants.find(v => product.attributes.every(a => !v.attributes[a.key] || v.attributes[a.key] === selection.attributes[a.key]));
};

export const optionAvailable = (product: Product, selection: Selection, key: string, value: string) => product.variants.some(v =>
    v.available && product.attributes.every(a => {
        const chosen = a.key === key ? value : selection.attributes[a.key];
        return !chosen || !v.attributes[a.key] || v.attributes[a.key] === chosen;
    })
);
